import React from "react";
import FormStart from "../../../form/automaticdrawer/FormStart";
import '../../../../css/overbox/AutomaticDrawerInformation.css';
import AutomaticDrawer from "../../../../stories/_setting/AutomaticDrawers/AutomaticDrawer";

const NewObject = props => {
    const { handleIndex } = props;

    return (
        <div className="overlayer">
            <div className="wrapOverbox">
                <div className="overbox start">
                    <FormStart object={ new AutomaticDrawer() } handleIndex={ handleIndex } />
                </div>
            </div>
        </div>
    )
}

export default NewObject;
